module.exports = __webpack_public_path__ + "static/img/15075B_X_03_20170725_LC.4873213.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/15075B_X_03_20170725_LC.png
// module id = 0C7Q
// module chunks = 0